import { type LucideIcon } from "lucide-react";

type StatsProps = {
    stat: {
        icon: LucideIcon, //eg: CloudSun from lucide react
        title: string,
        description: string
    }
}

export default function StatsCard({stat}: StatsProps) {

    const IconComponent = stat.icon;

    return (
        <div className="flex items-start sm:items-center justify-start gap-3 sm:gap-4 lg:gap-5">
            <div className="flex items-center justify-center bg-accent p-2 sm:p-3 rounded-full flex-shrink-0">
                <IconComponent size={24} className="sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-green-900"/>
            </div>
            <div className="flex-1 flex flex-col items-start justify-start min-w-0">
                <h3 className="font-bold text-base sm:text-lg lg:text-xl text-accent leading-tight">
                    {stat.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-100 mt-1 leading-relaxed">
                    {stat.description}
                </p>
            </div>
        </div>
    );
}